// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circular-percent[data-v-778e5d57]{position:relative;display:inline-block}svg[data-v-778e5d57]{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}circle[data-v-778e5d57]{stroke:#9a7c5d;stroke-width:5px}circle.bg[data-v-778e5d57]{stroke-width:1px;stroke:#565351}@media only screen and (max-width: 599px){.info span[data-v-778e5d57]{position:absolute;top:12px;left:75px}}", ""]);
// Exports
module.exports = exports;
